<template>
  <div>
    <label :for="inputID()" v-if="!!label">
      {{ label }} <em v-if="!fieldIsRequired" class="text-muted fw-100">- Optional</em>
    </label>

    <Popover v-if="helpTooltip && helpTooltip.length" :content="helpTooltip" placement="right">
      <i class="si si-question va-middle"></i>
    </Popover>

    <div class="push-5" v-if="helpText && helpText.length">
      <em class="text-muted">{{ helpText }}</em>
    </div>

    <div v-bind:class="{ 'has-error': hasErrors }">
      <slot :id="inputID()"></slot><!-- id slotProp used in parent context as input :id for accessibility -->
    </div>

    <div v-if="hasErrors" class="push-5-t has-error">
      <div class="help-block animated fadeInDown push-5-t" v-for="(err, idx) in errors" :key="idx">{{ err }}</div>
    </div>
  </div>
</template>

<script lang="ts">
  import { Component, Prop, Vue } from 'vue-facing-decorator'
  import FormTypes from '../../types/forms';
  import Popover from './Popover.vue';
  import ComponentID from '../../mixins/ComponentID';

  interface FormField extends ComponentID {}

  @Component({
    components: {
      Popover,
    },
    mixins: [ComponentID]
  })
  class FormField extends Vue {
    @Prop({ type: String }) id!: string;
    @Prop({ type: String }) label!: string;
    @Prop({ type: String }) helpText!: string;
    @Prop({ type: String }) helpTooltip!: string;
    @Prop({ type: Object }) v!: FormTypes.Validator;
    @Prop val!: any;
    @Prop({ default: true }) showErrors!: boolean;

    get errors(): Array<string> {
      if (!this.v) { return []; }
      return this.fieldErrors(this.label, this.val, this.v);
    }
    get fieldIsRequired(): boolean {
      if (!this.v) { return false; }
      return !!this.v.required;
    }
    get hasErrors(): boolean {
      return this.showErrors && !!this.errors.length;
    }
    inputID(): string {
      return !!this.id ? this.id : this.componentID;
    }
  }
  export default FormField;
</script>
